"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickShadesFromStack = void 0;
var NominalContrasts_1 = require("../utils/NominalContrasts");
var findExactColorIndex_1 = require("./findExactColorIndex");
function pickShadesFromStack(swatches, _safeMode, preferFormula) {
    if (preferFormula === void 0) { preferFormula = null; }
    var baseIndexInStack = (0, findExactColorIndex_1.findExactColorIndex)(swatches);
    var base = swatches[baseIndexInStack].exactColor;
    var container;
    var accent;
    var hover;
    var isLight = (0, NominalContrasts_1.isLightColor)(base, preferFormula);
    var isWhite = (0, NominalContrasts_1.isWhiteColor)(base);
    var isCloseToWhite = (0, NominalContrasts_1.isCloseToWhiteIndex)(baseIndexInStack);
    if (baseIndexInStack <= NominalContrasts_1.NominalContrasts['10']) {
        container = swatches[baseIndexInStack + 1].generatedColor;
        accent = swatches[baseIndexInStack + 2].generatedColor;
        hover = swatches[baseIndexInStack + 3].generatedColor;
    }
    else if (baseIndexInStack === NominalContrasts_1.NominalContrasts['13']) {
        container = swatches[baseIndexInStack - 1].generatedColor;
        accent = swatches[baseIndexInStack + 1].generatedColor;
        hover = swatches[baseIndexInStack + 2].generatedColor;
    }
    else if (baseIndexInStack === NominalContrasts_1.NominalContrasts['30'] || (baseIndexInStack === NominalContrasts_1.NominalContrasts['45'] && isLight)) {
        container = swatches[baseIndexInStack - 1].generatedColor;
        accent = swatches[baseIndexInStack - 2].generatedColor;
        hover = swatches[baseIndexInStack - 3].generatedColor;
    }
    else if (baseIndexInStack === NominalContrasts_1.NominalContrasts['45'] && !isLight) {
        container = swatches[baseIndexInStack + 1].generatedColor;
        accent = swatches[baseIndexInStack + 2].generatedColor;
        hover = swatches[baseIndexInStack + 3].generatedColor;
    }
    else if (baseIndexInStack === NominalContrasts_1.NominalContrasts['150']) {
        container = swatches[baseIndexInStack - 2].generatedColor;
        accent = swatches[baseIndexInStack - 1].generatedColor;
        hover = swatches[baseIndexInStack + 1].generatedColor;
    }
    else if (baseIndexInStack === NominalContrasts_1.NominalContrasts.max) {
        container = swatches[baseIndexInStack - 2].generatedColor;
        accent = swatches[baseIndexInStack - 1].generatedColor;
        hover = swatches[baseIndexInStack - 3].generatedColor;
    }
    else if (isLight) {
        container = swatches[baseIndexInStack - 1].generatedColor;
        accent = swatches[baseIndexInStack + 1].generatedColor;
        hover = swatches[baseIndexInStack - 2].generatedColor;
    }
    else {
        container = swatches[baseIndexInStack - 1].generatedColor;
        accent = swatches[baseIndexInStack + 1].generatedColor;
        hover = swatches[baseIndexInStack + 2].generatedColor;
    }
    return {
        base: base,
        container: container,
        accent: accent,
        hover: hover,
        baseIndexInStack: baseIndexInStack,
        isLight: isLight,
        isDark: !isLight,
        isWhite: isWhite,
        isCloseToWhite: isCloseToWhite
    };
}
exports.pickShadesFromStack = pickShadesFromStack;
//# sourceMappingURL=pickShadesFromStack.js.map